export { AccordionFade } from './accordion-fade.component';
